import { Types } from '../actions/testActions'

const initialState = {
    testCriterias: [],
    loading: false,
    test: {},
    inputEnabled: {},
    comment: '',
    menu: []
};


export const testReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.GET_TEST_CRITERIAS: {
            return {
                ...state,
                loading: true
            }
        }

        case Types.GET_TEST_CRITERIASSUCCESS: {
            return {
                ...state,
                loading: false,
                testCriterias: action.payload.testCriterias
            }
        }

        case Types.SET_TEST: {
            const { FieldText, Id, DataType } = action.payload;
            const currentState = state.inputEnabled[FieldText] || { state: false, id: Id };
            return {
                ...state,
                inputEnabled: {
                    ...state.inputEnabled,
                    [FieldText]: {
                        ...currentState,
                        state: !currentState.state,
                        dataType: DataType
                    }
                }
            };
        }

        case Types.SET_INITIAL_INPUT_ENABLED: {
            return {
                ...state,
                inputEnabled: action.payload
            };
        }

        case Types.SET_INPUT_TEXT: {
            const { FieldText, Value, Value1, DataType } = action.payload;
            return {
                ...state,
                inputEnabled: {
                    ...state.inputEnabled,
                    [FieldText]: {
                        ...state.inputEnabled[FieldText],
                        value: Value,
                        value1: Value1
                    }
                }
            };
        }

        case Types.HANDLE_COMMENT_CHANGE: {
            const { comment } = action.payload;
            return {
                ...state,
                comment: comment
            }
        }

        case Types.RESET_MODEL: {
            return initialState;
        }


        case Types.SET_MENU: {
            return {
                ...state,
                menu: action.payload
            }
        }

        default:
            return state;
    }

};